// extracted by mini-css-extract-plugin
export var equalColumn = "_ds-0";